<template>
    <div>

        <form class="divide-y divide-gray-200" action="#" method="POST">
            <!-- Profile section -->
            <div class="py-6 px-4 sm:p-6 lg:pb-8">
              <div>
                <h2 class="text-lg leading-6 font-medium text-gray-900">Account</h2>
                <!-- <p class="mt-1 text-sm text-gray-500">
                  Manage your account.
                </p> -->
              </div>

                <ul class="mt-2 divide-y divide-gray-200">
                    <li class="py-4">
                        <div class="sm:flex sm:flex-row sm:items-center justify-between">
                            <div class="flex flex-col">
                                <p class="text-sm font-medium text-gray-900" id="privacy-option-1-label">
                                    Change Sign-in Email
                                </p>
                                <p class="text-sm text-gray-500" id="privacy-option-1-description">
                                    Change the email address you use to sign-in with.
                                </p>
                            </div>

                            <tti-button v-if="!isChangingEmail" @click="isChangingEmail = true" size="small" theme="outline" class="mt-2 sm:mt-0">
                                Change Email
                            </tti-button>
                        </div>

                        <form v-if="isChangingEmail" @submit.prevent="onChangeEmail">
                            <div class="mt-3 grid grid-cols-12 gap-6 divide-y divide-gray-200">
                                <div class="col-span-12 sm:col-span-6">
                                    <label for="ceNewEmail" class="block text-sm font-medium text-gray-700">New Email</label>
                                    <input v-model="ceNewEmail" type="text" name="ceNewEmail" id="ceNewEmail" autocomplete="email" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm">
                                    <p v-if="$v.ceNewEmail.$dirty && !$v.ceNewEmail.required" class="text-sm text-red-600">Please enter your new email address.</p>
                                    <p v-if="!$v.ceNewEmail.email" class="text-sm text-red-600">Please enter a valid email address.</p>
                                    <p v-if="!$v.ceNewEmail.notTaken" class="text-sm text-red-600">This email is already registered to another account.</p>
                                </div>
                            </div>
                            <div class="mt-3 grid grid-cols-12 gap-6 divide-y divide-gray-200">
                                <div class="col-span-12 sm:col-span-6">
                                    <label for="ceCurrentPassword" class="block text-sm font-medium text-gray-700">Current Password</label>
                                    <input v-model="ceCurrentPassword" type="password" name="ceCurrentPassword" id="ceCurrentPassword" autocomplete="current-password" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm">
                                    <p v-if="$v.ceCurrentPassword.$dirty && !$v.ceCurrentPassword.required" class="text-sm text-red-600">Please enter your current password.</p>
                                    <p v-if="!$v.ceCurrentPassword.correct" class="text-sm text-red-600">Your password is incorrect.</p>
                                </div>
                            </div>
                            <div class="mt-3">
                                <tti-button type="submit" :loading="savingChangeEmail" :disabled="savingChangeEmail">
                                    Change Email
                                </tti-button>
                                <tti-button @click="cancelChangingEmail" :disabled="savingChangeEmail" theme="outline" class="ml-1">
                                    Cancel
                                </tti-button>
                            </div>
                        </form>
                    </li>
                    <li class="py-4">
                        <div class="sm:flex sm:flex-row sm:items-center justify-between">
                            <div class="flex flex-col">
                                <p class="text-sm font-medium text-gray-900" id="privacy-option-1-label">
                                    Change Password
                                </p>
                                <p class="text-sm text-gray-500" id="privacy-option-1-description">
                                    Change your password.
                                </p>
                            </div>

                            <tti-button v-if="!isChangingPassword" @click="isChangingPassword = true" size="small" theme="outline" class="mt-2 sm:mt-0">
                                Change Password
                            </tti-button>
                        </div>

                        <form v-if="isChangingPassword" @submit.prevent="onChangePassword">
                            <div class="mt-3 grid grid-cols-12 gap-6 divide-y divide-gray-200">
                                <div class="col-span-12 sm:col-span-6">
                                    <label for="cpCurrentPassword" class="block text-sm font-medium text-gray-700">Current Password</label>
                                    <input v-model="cpCurrentPassword" type="password" name="cpCurrentPassword" id="cpCurrentPassword" autocomplete="current-password" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm">
                                    <p v-if="$v.cpCurrentPassword.$dirty && !$v.cpCurrentPassword.required" class="text-sm text-red-600">Please enter your current password.</p>
                                    <p v-if="!$v.cpCurrentPassword.correct" class="text-sm text-red-600">Your password is incorrect.</p>
                                </div>
                            </div>
                            <div class="mt-3 grid grid-cols-12 gap-6 divide-y divide-gray-200">
                                <div class="col-span-12 sm:col-span-6">
                                    <label for="cpNewPassword" class="block text-sm font-medium text-gray-700">New Password</label>
                                    <input v-model="cpNewPassword" type="password" name="cpNewPassword" id="cpNewPassword" autocomplete="new-password" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm">
                                    <p v-if="$v.cpNewPassword.$dirty && !$v.cpNewPassword.required" class="text-sm text-red-600">Please enter a new password.</p>
                                </div>
                            </div>
                            <div class="mt-3">
                                <tti-button type="submit" :loading="savingChangePassword" :disabled="savingChangePassword">
                                    Change Password
                                </tti-button>
                                <tti-button @click="cancelChangingPassword" :disabled="savingChangePassword" theme="outline" class="ml-1">
                                    Cancel
                                </tti-button>
                            </div>
                        </form>
                    </li>
                    <!-- <li class="py-4">
                        <div class="sm:flex sm:flex-row sm:items-center justify-between">
                            <div class="flex flex-col">
                                <p class="text-sm font-medium text-gray-900" id="privacy-option-1-label">
                                    Close Account
                                </p>
                                <p class="text-sm text-gray-500" id="privacy-option-1-description">
                                    Close down your account and delete all data.
                                </p>
                            </div>

                            <tti-button v-if="!isDeletingAccount" @click="isDeletingAccount = true" size="xsmall" theme="outline" class="mt-2 sm:mt-0">
                                Close Account
                            </tti-button>
                        </div>

                        <div v-if="isDeletingAccount">
                            <div class="mt-3 font-bold">
                                Are you sure you want to close your account? This action cannot be undone.
                            </div>
                            <div class="mt-3">
                                <tti-button color="red">
                                    Close Account
                                </tti-button>
                                <tti-button @click="isDeletingAccount = false" theme="outline" class="ml-1">
                                    Cancel
                                </tti-button>
                            </div>
                        </div>
                    </li> -->
                </ul>


            </div>
        </form>

    </div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'

import UserService from '../services/UserServices'
const userService = new UserService();

export default {
    components: {
        'tti-button': () => import('./TailwindButton')
    },
    data() {
        return {
            isChangingEmail: false,
            ceNewEmail: null,
            ceCurrentPassword: null,
            savingChangeEmail: false,
            ceIncorrectCurrentPassword: false,
            ceEmailTaken: false,
            ceServerError: null,
            isChangingPassword: false,
            cpCurrentPassword: null,
            cpNewPassword: null,
            savingChangePassword: false,
            cpIncorrectCurrentPassword: false,
            isDeletingAccount: false,
        }
    },
    validations: {
        ceNewEmail: {
            required,
            email,
            notTaken: function() { return !this.ceEmailTaken; },
        },
        ceCurrentPassword: {
            required,
            correct: function() { return !this.ceIncorrectCurrentPassword; }
        },
        cpCurrentPassword: {
            required,
            correct: function() { return !this.cpIncorrectCurrentPassword; }
        },
        cpNewPassword: {
            required
        }
    },
    watch: {
        cpCurrentPassword() {
            this.cpIncorrectCurrentPassword = false;
        }
    },
    methods: {
        async onChangeEmail() {
            this.ceEmailTaken = false;
            this.ceIncorrectCurrentPassword = false;
            
            this.$v.ceNewEmail.$touch();
            this.$v.ceCurrentPassword.$touch();

            if (this.$v.ceNewEmail.$invalid || this.$v.ceCurrentPassword.$invalid)
                return;

            this.savingChangeEmail = true;

            try {
                await userService.changeEmail(this.ceNewEmail, this.ceCurrentPassword);

                this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
                this.isChangingEmail = false;
                this.resetChangingEmail();
            } catch (error) {
                switch (error.response.data) {
                    case 'UsernameTaken':
                        this.ceEmailTaken = true; break;
                    case 'IncorrectPassword':
                        this.ceIncorrectCurrentPassword = true; break;
                }
            } finally {
                this.savingChangeEmail = false;
            }
        },
        cancelChangingEmail() {
            this.isChangingEmail = false;
            this.resetChangingEmail();
        },
        resetChangingEmail() {
            this.ceNewEmail = null;
            this.ceCurrentPassword = null;
            this.ceEmailTaken = false;
            this.ceIncorrectCurrentPassword = false;
            this.$v.$reset();
        },
        async onChangePassword() {
            this.cpIncorrectCurrentPassword = false;

            this.$v.cpCurrentPassword.$touch();
            this.$v.cpNewPassword.$touch();

            if (this.$v.cpCurrentPassword.$invalid || this.$v.cpNewPassword.$invalid)
                return;
            
            this.savingChangePassword = true;

            try {
                await userService.changePassword(this.cpCurrentPassword, this.cpNewPassword);

                this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
                this.isChangingPassword = false;
                this.resetChangingPassword();    
            } catch(error) {
                this.cpIncorrectCurrentPassword = true;
            } finally {
                this.savingChangePassword = false;
            }
        },
        cancelChangingPassword() {
            this.isChangingPassword = false;
            this.resetChangingPassword();
        },
        resetChangingPassword() {
            this.cpCurrentPassword = null;
            this.cpNewPassword = null;
            this.cpIncorrectCurrentPassword = false;
            this.$v.$reset();
        }
    }
}
</script>